// import receipt1 from "../cert_templates/receipt1.png";
import receipt2 from "../cert_templates/receipt2.png";

export const templates = [
    // { name: "receipt1", img: receipt1 },
    { name: "receipt2", img: receipt2 },
]